export const handleImgError = e => {
  e.target.src = '/no-image.jpg';
};

export const handleConvertToBase64 = async file => {
  const reader = new FileReader();
  return new Promise(resolve => {
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
};

/**
 * Remove valores vazios (string vazia, null, undefined) de um objeto de filtros.
 * Isso garante que queryKeys sejam consistentes e evita requisições duplicadas.
 */
export const cleanFilters = <T extends Record<string, any>>(filters: T): Partial<T> => {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined,
    ),
  ) as Partial<T>;
};

/**
 * Retorna a cor do progresso baseado na porcentagem do limite atingido.
 * Usado para visualizar o status do regime tributário.
 */
export const getProgressColor = (percentage: number): string => {
  if (percentage >= 80) return 'red';
  if (percentage >= 60) return 'orange';
  if (percentage >= 40) return 'yellow';
  return 'green';
};
